/* eslint-disable indent */
import styled, { css } from 'styled-components';

export const Container = styled.section`
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
  height: 87%;
  display: flex;
`;

export const MultiMapConteiner = styled.div``;

export const MainContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  overflow-x: hidden;

  ${(props) =>
    props.numberOfMaps === 4 &&
    css`
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(2, 1fr);
      grid-column-gap: 0px;
      grid-row-gap: 0px;
    `}

  ${(props) =>
    props.numberOfMaps === 3 &&
    css`
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(2, 1fr);
      grid-column-gap: 0px;
      grid-row-gap: 0px;
    `}

  ${(props) =>
    props.numberOfMaps === 2 &&
    css`
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: repeat(2, 1fr);
      grid-column-gap: 0px;
      grid-row-gap: 0px;
    `}
`;

export const MapContainer = styled.div`
  width: 100%;
  height: 100%;
`;

export const SideNav = styled.div`
  height: 100%;
  width: 40px;
  transition: 0.5s;

  padding: 20px 0 20px 0;
  display: flex;

  ${(props) =>
    props.isOpened &&
    css`
      width: 480px;
      padding: 20px 0 20px 20px;
    `}
`;

export const ButtonContainer = styled.div`
  height: 100%;
  width: 40px;
  float: right;
  display: flex;
  justify-content: center;
  align-items: flex-end;

  button {
    background: transparent;
    border: 0;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      transition: 0.8s;
      ${(props) =>
        props.isOpened &&
        css`
          -ms-transform: rotate(-180deg);
          transform: rotate(-180deg);
        `}
    }
  }
`;
